import { Link } from "react-router-dom"
import { Check } from "lucide-react";
import { Card, CardContent,CardHeader,CardTitle } from "../ui/card";
import HealthCheckup from "../images/Master Health Checkup.png"
import Women from "../images/Executive Health Check - Women.png"
import Men from "../images/Executive Health Check - Men.png"
import Cardiac from "../images/Cardiac Profile.png"
import Anemia from "../images/Anemia Profile.png"
import Bone from "../images/Metabolic Bone Profile.png"
import Liver from "../images/Liver Profile.png"
import Renal from "../images/Renal Profile.png"
import Baby from "../images/Well Baby Check Profile.png"
import Diabetic from "../images/Diabetic Profile.png"
import Pancreas from "../images/pancreas.png"
import Brain from "../images/brain.png"
import ComprehensiveImage from "../images/Comprehensive Testing.png";
import ExpertConsultation from "../images/Expert Consultation.png";
import AdvancedEquipment from "../images/Advanced Equipment.png";
import AffordablePricing from "../images/Affordable Pricing.png";
import SEO from '../pages/SEO';

const HealthPackages = () => {
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },


  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/health-packages"
  },
  "headline": "Preventive Health Check Packages at MAMS Hospitals",
  "description": "Comprehensive preventive health screening packages at MAMS Hospitals—like Master Health Checkup, Executive Health Checks, Cardiac Profiles, and more—to help you detect issues early and stay healthy.",
  "author": {
    "@type": "Organization",
    "name": "MAMS Hospitals"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mamshospitals.com/MAMS-Logo.png"
    }
  },
  "datePublished": "2025-09-10",
  "dateModified": "2025-09-10",
  "articleSection": [
    "Most Popular Packages",
    "Specialized Profiles",
    "How It Works",
    "Why Choose Us"
  ],
  "mainEntity": {
    "@type": "ItemList",
    "name": "Health Packages Offered",
    "itemListElement": [
      {
        "@type": "Offer",
        "price": "6000",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Master Health Checkup",
          "description": "Comprehensive health check with ~20 tests including Hemogram, BGT, CUE, ESR, HIV, HBsAg, HCV, FBS and more."
        }
      },
      {
        "@type": "Offer",
        "price": "3600",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Executive Health Check - Women",
          "description": "Women's specific check with ~15 tests including LFT, FLP, Calcium, Phosphorus, Uric Acid, Electrolytes, LH, FSH and more."
        }
      },
      {
        "@type": "Offer",
        "price": "3000",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Executive Health Check - Men",
          "description": "Men’s health check with ~20 tests including Hemogram, BGT, CUE, ESR, HIV, HBsAg, HCV, FBS and more."
        }
      },
      {
        "@type": "Offer",
        "price": "2350",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Advance Cardiac Profile",
          "description": "Cardiac-specific testing including Hemogram, CUE, FBS, PLBS, FLP, RFT, TSH, ECG, etc."
        }
      },
      {
        "@type": "Offer",
        "price": "1650",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Basic Cardiac Profile",
          "description": "Basic heart check including Hemogram, CUE, FBS, PLBS, FLP, TMT, RFT, TSH and more."
        }
      },
      {
        "@type": "Offer",
        "price": "800",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "url": "https://mamshospitals.com/health-packages",
        "itemOffered": {
          "@type": "MedicalTestPanel",
          "name": "Diabetic Profile",
          "description": "Diabetes assessment with Hemogram, CUE, FBS, PLBS, HbA1C, Spot Urine for Microalbumin."
        }
      }
    ]
  },
  "keywords": [
    "health packages Hyderabad",
    "Master Health Checkup MAMS",
    "preventive health screening Telangana",
    "executive health checkup Hyderabad"
  ]
}
];

    const healthPackages = [
    {
      id: 1,
      name: "Master Health Checkup",
      price: "₹6,000",
      category: "Comprehensive",
      image: HealthCheckup,
      tests: [
        "Hemogram",
        "BGT",
        "CUE",
        "ESR",
        "HIV",
        "HBsAg",
        "HCV",
        "FBS",
        "PLBS",
        "RFT",
        "Lipid Profile",
        "Calcium",
        "Phosphorus",
        "Electrolytes",
        "Uric Acid",
        "Thyroid Profile",
        "Vitamin D",
        "Vitamin B12",
        "USG of Abdomen",
        "Chest X-Ray PA View",
        "ECG",
        "Pap Smear",
      ],
      popular: true,
    },
    {
      id: 2,
      name: "Executive Health Check - Women",
      price: "₹3,600",
      category: "Women's Health",
      image: Women,
      tests: [
        "LFT",
        "FLP",
        "Calcium",
        "Phosphorus",
        "Uric Acid",
        "Electrolytes",
        "LH",
        "FSH",
        "PRL",
        "TFT",
        "Vitamin D",
        "B12",
        "Iron",
        "Ferritin",
        "Mammography",
        "PAP Smear",
        "Chest X-Ray",
        "ECG",
        "USG",
      ],
      popular: false,
    },
    {
      id: 3,
      name: "Executive Health Check - Men",
      price: "₹3,000",
      category: "Men's Health",
      image: Men,
      tests: [
        "Hemogram",
        "BGT",
        "CUE",
        "ESR",
        "HIV",
        "HBsAg",
        "HCV",
        "FBS",
        "PLBS",
        "RFT",
        "Lipid Profile",
        "Calcium",
        "Phosphorus",
        "Electrolytes",
        "Uric Acid",
        "Thyroid Profile",
        "Vitamin D",
        "Vitamin B12",
        "ECG",
        "PSA",
        "LFT",
        "Chest X-Ray PA View",
        "USG of Abdomen",
      ],
      popular: false,
    },
    {
      id: 4,
      name: "Neurology Profile",
      price: "₹3,499",
      category: "Specialized",
      image: Brain,
      tests: ["CBP", "RFT", "Vitamin B12", "Thyroid Profile", "HbA1C", "Fast - Lipid Profile", "NCS"],
      popular: false,
    },
    {
      id: 5,
      name: "Advance Cardiac Profile",
      price: "₹2,350",
      category: "Cardiac",
      image: Cardiac,
      tests: ["Hemogram", "CUE", "FBS", "PLBS", "FLP", "RFT", "TSH", "ECG", "2D Echo", "Electrolytes", "X-Ray PA View"],
      popular: false,
    },
    {
      id: 6,
      name: "Basic Cardiac Profile",
      price: "₹1,650",
      category: "Cardiac",
      image: Cardiac,
      tests: [
        "Hemogram",
        "CUE",
        "FBS",
        "PLBS",
        "FLP",
        "TMT",
        "RFT",
        "TSH",
        "ECG",
        "2D Echo",
        "Electrolytes",
        "X-Ray PA View",
      ],
      popular: false,
    },
    {
      id: 7,
      name: "Anemia Profile",
      price: "₹2,190",
      category: "Specialized",
      image: Anemia,
      tests: [
        "Hemogram",
        "Reticulocyte Count",
        "CUE",
        "Iron",
        "TIBC",
        "Ferritin",
        "Vitamin B12",
        "Folate",
        "ESR",
        "Transferrin Saturation",
        "Malaria Rapid Test (PV/PF)",
        "Stool For Ova/cyst",
        "Occult Blood",
        "Hemogram",
      ],
      popular: false,
    },
    {
      id: 8,
      name: "Metabolic Bone Profile",
      price: "₹1,365",
      category: "Specialized",
      image: Bone,
      tests: ["Hemogram", "CUE", "Calcium", "Phosphorus", "Uric Acid", "RFT", "IPTH", "MG", "Hemogram"],
      popular: false,
    },
    {
      id: 9,
      name: "Liver Profile",
      price: "₹3,500",
      category: "Specialized",
      image: Liver,
      tests: ["LFT (Liver Function Test)", "Hemogram", "CUE", "PT+INR", "APTT", "LFT", "GGT", "HBsAg", "HCV"],
      popular: false,
    },
    {
      id: 10,
      name: "Healthy Women Check Profile",
      price: "₹1,550",
      category: "Women's Health",
      image:    Women,
      tests: ["Hemogram", "BGT", "CUE", "ESR", "HIV", "HBsAg", "HCV", "RPR", "FBS", "PLBS"],
      popular: false,
    },
    {
      id: 11,
      name: "Renal Profile",
      price: "₹2,600",
      category: "Specialized",
      image: Renal,
      tests: ["Hemogram", "CUE", "FBS", "PLBS", "RFT", "Electrolytes", "Spot Urine P/c Ratio", "X-Ray KUB"],
      popular: false,
    },
    {
      id: 12,
      name: "Well Baby Check Profile",
      price: "₹900",
      category: "Pediatric",
      image: Baby,
      tests: ["Hemogram", "Lipid Profile", "HBsAg", "HIV", "HCV", "FBS", "PLBS", "HbA1C", "CUE", "LFT"],
      popular: false,
    },
    {
      id: 13,
      name: "Diabetic Profile",
      price: "₹800",
      category: "Specialized",
      image: Diabetic,
      tests: ["Hemogram", "CUE", "FBS", "PLBS", "HbA1C", "Spot Urine for Microalbumin"],
      popular: false,
    },
    {
      id: 14,
      name: "Cardiac Profile",
      price: "₹750",
      category: "Cardiac",
      image: Cardiac,
      tests: [
        "Hemogram",
        "CUE",
        "PT+INR",
        "FBS",
        "PLBS",
        "FLP",
        "CK",
        "CKMB",
        "TROP-I",
        "TSH",
        "Electrolytes",
        "CRP",
        "ASO",
        "ECG",
        "2D Echo",
        "X-Ray PA View",
      ],
      popular: false,
    },
    {
      id: 15,
      name: "Pancreatic Profile",
      price: "₹450",
      category: "Specialized",
      image: Pancreas,
      tests: ["Hemogram", "CUE", "Amylase", "Lipase", "LFT", "RFT"],
      popular: false,
    },
  ]

  // const categories = ["All", "Comprehensive", "Cardiac", "Women's Health", "Men's Health", "Specialized", "Pediatric"]
  return (
    <>
      <SEO
        title="Health Checkup Packages – MAMS Hospital Hyderabad | Preventive & Executive Screening"
        description="Choose from preventive, executive, women’s and senior citizen health checkup packages at MAMS Hospital, Bachupally – comprehensive screening with expert care."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Mamata Academy of Medical Sciences hospital,health checkup packages MAMS Hospital Hyderabad, preventive health packages Telangana, full body medical screening MAMS, executive health checkup Hyderabad, women’s health package Hyderabad, senior citizen health package Hyderabad"
        schema={schema}
      canonicalUrl="https://mamshospitals.com/health-packages"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-apple-gray-50 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-semibold text-apple-gray-500 mb-6">
              Preventive Health Check Packages
            </h1>
            <p className="text-lg text-gray-700 mb-4">Helping You Live Longer, Healthier, and Better</p>
            <p className="text-gray-700">
              Comprehensive health screening packages designed to detect potential health issues early and maintain your
              well-being.
            </p>
          </div>
        </div>
      </section>
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {healthPackages.map((pkg) => (
              <Card
                key={pkg.id}
                className={`relative border-2 rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-lg ${
                  pkg.popular
                    ? "border-apple-teal bg-gradient-to-b from-apple-teal/5 to-white"
                    : "border-apple-gray-100 hover:border-apple-teal/50"
                }`}
              >
                {pkg.popular && (
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-apple-teal text-white px-4 py-1 rounded-b-lg text-sm font-medium z-10">
                    Most Popular
                  </div>
                )}

                <CardHeader className="text-center pb-4">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden bg-apple-gray-50 border-4 border-apple-teal/20">
                    <img
                      src={pkg.image || "/placeholder.svg"}
                      alt={pkg.name}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="text-xl font-semibold text-apple-gray-500 mb-2">
                    {pkg.name}
                  </div>

                  <div className="text-sm text-gray-700 mb-2">
                    {pkg.category}
                  </div>
                </CardHeader>

                <CardContent className="pt-0">
                  <div className="mb-6">
                    <div className="font-semibold text-apple-gray-500 mb-3">
                      Tests Included:
                    </div>                    <div className="max-h-40 overflow-y-auto">
                      <ul className="space-y-1">
                        {pkg.tests.slice(0, 8).map((test, index) => (
                          <li key={index} className="flex items-start gap-2 text-sm">
                            <Check className="h-3 w-3 text-apple-teal mt-1 flex-shrink-0" />
                            <span className="text-gray-700">{test}</span>
                          </li>
                        ))}
                        {pkg.tests.length > 8 && (
                          <li className="text-sm text-apple-teal font-medium">+{pkg.tests.length - 8} more tests</li>
                        )}
                      </ul>
                    </div>
                  </div>

                  {/* <Link to="/book-appointment">
                    <div
                      className={`w-full text-center py-2 px-4 rounded-full font-medium transition-colors justify-center ${
                        pkg.popular ? "apple-button" : "apple-button-secondary "
                      }`}
                    >
                      Book Package
                    </div>
                  </Link> */}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-apple-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">
              Why Choose Our Health Packages?
            </h2>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Our comprehensive health packages are designed by medical experts to provide thorough health assessments.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="border-apple-gray-100 rounded-3xl text-center">
              <CardContent className="p-6">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden bg-apple-gray-50">
                  <img
                    src={ComprehensiveImage}
                    alt="Comprehensive Testing"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Comprehensive Testing</h3>
                <p className="text-gray-700">
                  Complete range of tests covering all major health parameters and organ functions.
                </p>
              </CardContent>
            </Card>

            <Card className="border-apple-gray-100 rounded-3xl text-center">
              <CardContent className="p-6">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden bg-apple-gray-50">
                  <img
                    src={ExpertConsultation}
                    alt="Expert Consultation"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Expert Consultation</h3>
                <p className="text-gray-700">
                  Detailed report interpretation and consultation with our experienced physicians.
                </p>
              </CardContent>
            </Card>

            <Card className="border-apple-gray-100 rounded-3xl text-center">
              <CardContent className="p-6">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden bg-apple-gray-50">
                  <img
                   src={AdvancedEquipment}
                    alt="Advanced Equipment"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Advanced Equipment</h3>
                <p className="text-gray-700">
                  State-of-the-art diagnostic equipment ensuring accurate and reliable results.
                </p>
              </CardContent>
            </Card>

            <Card className="border-apple-gray-100 rounded-3xl text-center">
              <CardContent className="p-6">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full overflow-hidden bg-apple-gray-50">
                  <img
                    src={AffordablePricing}
                    alt="Affordable Pricing"
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Affordable Pricing</h3>
                <p className="text-gray-700">
                  Cost-effective packages offering maximum value for comprehensive health screening.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">How It Works</h2>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Simple steps to complete your health checkup and get comprehensive results.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-apple-teal text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                1
              </div>
              <h3 className="text-lg font-semibold text-apple-gray-500 mb-2">Choose Package</h3>
              <p className="text-gray-700">
                Select the health package that best suits your needs and requirements.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-apple-teal text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                2
              </div>
              <h3 className="text-lg font-semibold text-apple-gray-500 mb-2">Book Appointment</h3>
              <p className="text-gray-700">Schedule your convenient time slot for sample collection and tests.</p>
            </div>

            <div className="text-center">
              <div className="bg-apple-teal text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                3
              </div>
              <h3 className="text-lg font-semibold text-apple-gray-500 mb-2">Complete Tests</h3>
              <p className="text-gray-700">Visit our facility for sample collection and diagnostic procedures.</p>
            </div>

            <div className="text-center">
              <div className="bg-apple-teal text-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                4
              </div>
              <h3 className="text-lg font-semibold text-apple-gray-500 mb-2">Get Results</h3>
              <p className="text-gray-700">Receive detailed reports and consultation with our medical experts.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-apple-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-apple-teal text-white rounded-3xl p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-semibold mb-4">Ready to Take Charge of Your Health?</h2>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Don't wait for symptoms to appear. Book your preventive health checkup today and stay ahead of potential
              health issues.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* <Link to="/book-appointment">
                <div className="apple-button-secondary bg-white text-apple-teal hover:bg-apple-gray-50">
                  Book Health Package
                </div>
              </Link> */}
              {/* <Link to="/contact">
                <div className="apple-button-secondary bg-white/20 hover:bg-white/30 text-white border-white/30">
                  Contact Us
                </div>
              </Link> */}
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-apple-gray-500 mb-4">Need Help Choosing?</h2>
            <p className="text-gray-700 mb-6">
              Our healthcare experts can help you select the right health package based on your age, lifestyle, and
              health concerns.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+917399999981" className="apple-button">
                Call +91 7399999981
              </a>
              <a href="mailto:info@mamshospitals.com" className="apple-button-secondary">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </section>


      </div>
      </>
  )
}

export default HealthPackages
